let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("idfnC"), load("4AAsh")]).then(() => parcelRequire('YvPDh'));